import React, { useEffect, useState } from 'react';
import { useParams, useHistory, Link } from 'react-router-dom';
import axios from 'axios';
import { FaPlane, FaCar } from 'react-icons/fa';
import { IoHome } from 'react-icons/io5';
import { FaMapLocationDot } from 'react-icons/fa6';

const CourseDetails = () => {
  const { formationCode } = useParams();
  const history = useHistory();

  const [formation, setFormation] = useState(null);
  const [session, setSession] = useState([]);
  const [selectedSession, setSelectedSession] = useState(null);
  const [modeChoisi, setModeChoisi] = useState('Présentiel');
  const [loading, setLoading] = useState(true);
  const [errorMessage, setErrorMessage] = useState('');

  const Url = process.env.REACT_APP_URL_DEV;

  useEffect(() => {
    axios
      .get(`${Url}/api/Formation/formations/${formationCode}`)
      .then((response) => {
        const data = response.data.data?.[0];
        if (data) {
          setFormation(data);
          setSession(data.Session || []);
        }
      })
      .catch((err) => console.error('Erreur API :', err))
      .finally(() => setLoading(false));
  }, [formationCode]);

  const handleModeChange = (mode) => setModeChoisi(mode);

  const handleInscription = () => {
    if (!selectedSession && modeChoisi === 'Présentiel') {
      setErrorMessage('Veuillez choisir une session avant de continuer !');
      return;
    }

    history.push({
      pathname: '/Inscription',
      state: { formation, session: selectedSession, mode: modeChoisi },
    });
  };

  // Regrouper les sessions par ville
  const groupedSessions = session.reduce((acc, s) => {
    if (!acc[s.sessionVille]) acc[s.sessionVille] = [];
    acc[s.sessionVille].push(s);
    return acc;
  }, {});

  if (loading) return <p>Chargement...</p>;

  return (
    <div className="course-single-area pd-top-120 pd-bottom-90">
      <div style={{ padding: '40px' }}>
        <div className="row">
          {/* Contenu principal */}
          <div className="col-lg-8 col-md-12 col-sm-12 order-2 order-lg-1">
            <div className="course-course-detaila-inner">
              <h4 style={{ color: 'black' }}>{formation?.formationNom}</h4>

              {/* Onglets */}
              <div className="course-details-nav-tab text-center">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {[
                    'Objectifs',
                    'Programme',
                    'Prérequis',
                    'Public',
                    'Points Forts',
                    'Certification',
                  ].map((tab, i) => (
                    <li key={i} className="nav-item">
                      <a
                        className={`nav-link ${i === 0 ? 'active' : ''}`}
                        id={`tab${i + 1}-tab`}
                        data-toggle="tab"
                        href={`#tab${i + 1}`}
                        role="tab"
                      >
                        {tab}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className="tab-content" id="myTabContent">
                {[
                  formation?.formationObjectif,
                  formation?.formationProgramme,
                  formation?.formationPrerequis,
                  formation?.formationPublic,
                  formation?.formationPointFort,
                  formation?.formationCertif,
                ].map((content, i) => (
                  <div
                    key={i}
                    className={`tab-pane fade ${i === 0 ? 'show active' : ''}`}
                    id={`tab${i + 1}`}
                    role="tabpanel"
                  >
                    <p dangerouslySetInnerHTML={{ __html: content }} />
                  </div>
                ))}
              </div>

              <h2>NOS AVANTAGES</h2>
              <div className="row mt-2">
                <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                  <Link to="/VisaPage">
                    <FaPlane style={{ fontSize: '50px', color: 'red' }} />
                    <p style={{ fontWeight: '600', color: 'black' }}>Visa</p>
                  </Link>
                </div>
                <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                  <Link to="/HebegrementPage">
                    <IoHome style={{ fontSize: '50px', color: 'red' }} />
                    <p style={{ fontWeight: '600', color: 'black' }}>
                      Appui à lhébergement
                    </p>
                  </Link>
                </div>
                <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                  <Link to="/AccueilTransfertPage">
                    <FaCar style={{ fontSize: '50px', color: 'red' }} />
                    <p style={{ fontWeight: '600', color: 'black' }}>
                      Accueil & transfert
                    </p>
                  </Link>
                </div>
                <div className="col-lg-3 col-sm-6 col-md-6 text-center">
                  <Link to="/VisiteTouristPage">
                    <FaMapLocationDot
                      style={{ fontSize: '50px', color: 'red' }}
                    />
                    <p style={{ fontWeight: '600', color: 'black' }}>
                      Visites touristiques
                    </p>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="col-lg-4 col-md-12 col-sm-12 order-1 order-lg-2">
            <div className="td-sidebar">
              <div className="widget widget_feature">
                {/* Modes dynamiques */}
                {formation?.formationType && (
                  <div className="d-flex justify-content-center mg-top-90 mb-3">
                    {formation.formationType.split(',').map((type, index) => (
                      <button
                        key={index}
                        className={`custom-mode-btn mx-1 ${
                          modeChoisi === type.trim() ? 'selected' : ''
                        }`}
                        onClick={() => handleModeChange(type.trim())}
                        style={{ width: '130px' }}
                      >
                        {type.trim()}
                      </button>
                    ))}
                  </div>
                )}

                <ul className="mt-4">
                  <li>
                    <i className="fa fa-user" /> <span>Code Formation :</span>{' '}
                    {formation?.formationCode}
                  </li>
                  <li>
                    <i className="fa fa-clock-o" /> <span>Durée :</span>{' '}
                    {formation?.formationDuree}
                  </li>
                  <li>
                    <i className="fa fa-clipboard" /> <span>Langues :</span>{' '}
                    {formation?.formationLangue}
                  </li>
                </ul>

                <div className="price-wrap">
                  {Object.keys(groupedSessions).length > 0 ? (
                    Object.keys(groupedSessions).map((ville) => (
                      <div key={ville} className="accordion mb-3">
                        <div className="accordion-header">
                          <strong>
                            {ville}
                            {modeChoisi === 'Présentiel' &&
                              ` / Prix: ${groupedSessions[ville][0].sessionPrix}€`}
                          </strong>
                        </div>

                        <div className="card-body" style={{ padding: '10px' }}>
                          {groupedSessions[ville].map((s, idx) => (
                            <div
                              key={s.sessionId}
                              style={{
                                padding: '5px 0',
                                borderBottom: '1px solid #ddd',
                              }}
                            >
                              <label>
                                <input
                                  type="radio"
                                  name="session"
                                  value={s.sessionId}
                                  checked={
                                    selectedSession &&
                                    selectedSession.sessionId == s.sessionId
                                  }
                                  onChange={() => setSelectedSession(s)}
                                />{' '}
                                Session {idx + 1}: du {s.sessionDateDebut} au{' '}
                                {s.sessionDateFin}
                              </label>
                            </div>
                          ))}
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>Pas de sessions disponibles.</p>
                  )}

                  {errorMessage && (
                    <p style={{ color: 'red', fontWeight: 'bold' }}>
                      {errorMessage}
                    </p>
                  )}

                  <div style={{ marginBottom: '10px' }}>
                    <button
                      onClick={handleInscription}
                      style={{
                        backgroundColor: '#FFD000',
                        color: 'white',
                        fontWeight: 'bold',
                        border: 'none',
                        borderRadius: '8px',
                        padding: '10px 0',
                        fontSize: '16px',
                        minWidth: '200px',
                        cursor: 'pointer',
                      }}
                    >
                      {modeChoisi === 'En ligne'
                        ? 'Demande de devis'
                        : "S'inscrire"}
                    </button>
                  </div>

                  <div>
                    <Link
                      to={{
                        pathname: '/InscriptionMesure',
                        state: { formation },
                      }}
                    >
                      <button className="sur-mesure-button">Sur Mesure</button>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CourseDetails;
